export default "__VITE_ASSET__DQt_A5Ih__"